/* ==========================================================================
   easysea Campaign Theme Engine - comportamento (BF2026)
   Lo stato lo decide lo script in testa (snippets/es-campaign.liquid).
   Qui: testi nella lingua, date della fase, conto alla rovescia sulle date
   vere, prodotti in offerta presi dal catalogo, badge sulle card della home,
   striscia e fascia, nota nel carrello, pannello anteprima.
   Nessun popup, nessun lampeggio, nessun dato inventato.
   ========================================================================== */
(function () {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  function init() {
    var c = window.esCP, T = window.esCPT, d = document, h = d.documentElement;
    if (!c || !T) return;
    var st = c.eff, cm = c.effCm;
    if (c.pv) devPanel();
    if (!st || st === 'standard') return;
    var key = cm ? 'cyber-monday' : st, S = T.s[key] || {}, G = T.g;
    var root = (c.root || '/').replace(/\/$/, '');
    function all(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return '&#' + m.charCodeAt(0) + ';'; }); }
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function eur(n) { try { return new Intl.NumberFormat(h.lang || 'it', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(n); } catch (e) { return n.toFixed(2) + ' €'; } }

    /* fine fase: dalle finestre vere (CM e' l'ultimo giorno della finestra black-friday) */
    var end = 0, start = 0;
    c.win.forEach(function (w) { if (w[0] === st) { start = w[1]; end = w[2]; } });
    if (cm) start = c.cmS;
    var dates = '';
    try { var f = new Intl.DateTimeFormat(c.lang, { day: 'numeric', month: 'long', timeZone: 'Europe/Rome' }); dates = f.format(new Date(start * 1e3)) + ' → ' + f.format(new Date(end * 1e3 - 1e3)); } catch (e) {}

    var claimTxt = c.claim > 0 ? G.up + ' -' + c.claim + '%' : '';
    function fill(r) {
      all('[data-cp-t]', r).forEach(function (e) {
        var k = e.getAttribute('data-cp-t'), v = S[k] != null ? S[k] : G[k];
        if (k === 'price_lab') v = (G.price_lab || '').replace('{name}', S.name || '');
        e.textContent = v == null ? '' : v;
      });
      all('[data-cp-dates]', r).forEach(function (e) { e.textContent = dates; });
      all('[data-cp-claim]', r).forEach(function (e) {
        if (!c.claim) { e.textContent = ''; return; }
        e.innerHTML = e.getAttribute('data-cp-claim') === 'big' ? esc(G.up) + ' <b>-' + c.claim + '%</b>' : esc(claimTxt);
      });
    }
    fill(d);

    /* conto alla rovescia: tempo del server corretto sullo scarto dell'orologio del cliente */
    var skew = (c.t || c.now) * 1000 - Date.now();
    if (c.pv) skew = 0;
    function tick() {
      var now = c.pv && c.t ? c.t * 1000 + (Date.now() - t0) : Date.now() + skew;
      var s = Math.max(0, Math.floor((end * 1000 - now) / 1000));
      var D = Math.floor(s / 86400), H = Math.floor(s % 86400 / 3600), M = Math.floor(s % 3600 / 60), S2 = s % 60;
      var txt = (D > 0 ? D + G.d + ' ' : '') + pad(H) + ':' + pad(M) + ':' + pad(S2);
      all('[data-cp-cd]').forEach(function (e) { if (e.textContent !== txt) e.textContent = txt; });
      var map = { d: pad(D), h: pad(H), m: pad(M), s: pad(S2) };
      for (var k in map) all('[data-cp-cd-' + k + ']').forEach(function (e) { if (e.textContent !== map[k]) e.textContent = map[k]; });
    }
    var t0 = Date.now(); tick(); setInterval(tick, 1000);

    /* prodotti in offerta nella fascia: dal catalogo, solo con barrato vero */
    var pk = d.querySelector('[data-cp-picks]');
    if (pk) {
      fetch(root + '/collections/easysea-core/products.json?limit=60').then(function (r) { return r.json(); }).then(function (j) {
        var L = [];
        (j.products || []).forEach(function (p) {
          var t = (p.tags || []).join('|').toLowerCase(), hd = p.handle.toLowerCase();
          if (/no-campagne|no-bf|pre-assembled kits/.test(t) || (hd.indexOf('jake') >= 0 && hd.indexOf('kit') >= 0 && t.indexOf('bf26') < 0)) return;
          var v = (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0];
          var pr = parseFloat(v.price), ca = parseFloat(v.compare_at_price || 0);
          if (!(ca > pr) || !p.images || !p.images[0]) return;
          L.push({ p: p, pr: pr, ca: ca, x: Math.round((ca - pr) * 100 / ca) });
        });
        L.sort(function (a, b) { return b.x - a.x; });
        if (L.length < 3) return;
        pk.innerHTML = '<p class="cp-picks__t">' + esc(G.picks) + '</p><div class="cp-picks">' + L.slice(0, 3).map(function (o) {
          var src = o.p.images[0].src; src += (src.indexOf('?') > 0 ? '&' : '?') + 'width=360';
          return '<a class="cp-pick" href="' + root + '/products/' + esc(o.p.handle) + '"><span class="cp-pick__im"><img src="' + esc(src) + '" alt="' + esc(o.p.title) + '" loading="lazy" width="180" height="180"><span class="cp cp-badge">-' + o.x + '%</span></span>' +
            '<span class="cp-pick__b"><span>' + esc(o.p.title.split(' - ')[0]) + '</span><s>' + esc(eur(o.ca)) + '</s><em>' + esc(eur(o.pr)) + '</em></span></a>';
        }).join('') + '</div>';
      }).catch(function () {});
    }

    /* badge sulle card della home (le card v8 non passano dallo snippet product-card) */
    all('.v8c').forEach(function (a) {
      if (a.querySelector('.cp-badge')) return;
      var s = a.querySelector('.v8c__p s, .v8c__p del'), b = a.querySelector('.v8c__p b'), im = a.querySelector('.v8c__im');
      if (!s || !b || !im) return;
      var num = function (x) { return parseFloat(String(x.textContent).replace(/[^0-9,.]/g, '').replace(/\.(?=\d{3})/g, '').replace(',', '.')); };
      var was = num(s), nw = num(b); if (!(was > nw)) return;
      var x = Math.round((was - nw) * 100 / was); if (x < 1) return;
      var e = d.createElement('span'); e.className = 'cp cp-badge'; e.textContent = '-' + x + '%'; im.appendChild(e);
    });

    /* Chandlery in home: etichetta della fase */
    var cz = d.querySelector('.v8cz h2, .v8cz .v8t');
    if (cz && !d.querySelector('.v8cz .cp-chip')) cz.insertAdjacentHTML('beforebegin', '<a class="cp cp-chip" href="' + esc(root + '/collections/chandlery') + '">' + esc(S.name) + (claimTxt ? ' <b>' + esc(claimTxt) + '</b>' : '') + '</a>');

    /* striscia su categorie, ricerca, carrello */
    if (/\/(collections|search|cart)(\/|$|\?)/.test(location.pathname) && !d.querySelector('.cp-strip')) {
      var mn = d.querySelector('main');
      if (mn) {
        var s1 = d.createElement('div'); s1.className = 'cp cp-strip';
        s1.innerHTML = '<div class="cp-strip__in">' + (c.claim ? '<span class="cp-strip__claim">-' + c.claim + '%</span>' : '') +
          '<span><b>' + esc(S.name) + '</b>. ' + esc(G.no_code) + '</span>' +
          '<span class="cp-strip__cd">' + esc(G.ends) + ' <b data-cp-cd>--:--:--</b></span>' +
          (st === 'black-week' ? '<a class="cp-btn" href="' + esc(c.quick) + '">' + esc(G.quick) + '</a>' : '') + '</div>';
        mn.insertBefore(s1, mn.firstChild);
      }
    }

    /* fascia prima del footer, tutte le pagine tranne il carrello */
    if (!/\/cart/.test(location.pathname) && !d.querySelector('.cp-band')) {
      var tp = d.getElementById('cp-tpl-band'), ft = d.querySelector('[id$="__es_footer"], footer');
      if (tp && ft) { var nb = tp.content.firstElementChild.cloneNode(true); ft.parentNode.insertBefore(nb, ft); fill(nb); }
    }

    /* newsletter del footer: stesso modulo, messaggio della fase */
    all('.esf h2, .esf__nl h2, .esf [class*="newsletter"] h2').slice(0, 1).forEach(function (e) {
      if (!e.querySelector('.cp-nl-tag')) e.insertAdjacentHTML('beforeend', '<span class="cp cp-nl-tag">' + esc(S.name) + '</span>');
    });

    /* carrello: nota di campagna (e Ordine rapido in Black Week) */
    function cartNote() {
      var cd = d.querySelector('cart-drawer'), host = cd && (cd.querySelector('.drawer__content') || cd);
      var pg = d.querySelector('main [id$="__main"] .cart, main [id$="__main"]');
      [host, /\/cart/.test(location.pathname) ? pg : null].forEach(function (x) {
        if (!x || x.querySelector(':scope > .cp-cart')) return;
        var e = d.createElement('div'); e.className = 'cp cp-cart';
        e.innerHTML = '<b>' + esc(S.name) + '</b><span>' + esc(G.no_code) + '</span>' + (st === 'black-week' ? '<a href="' + esc(c.quick) + '">' + esc(G.quick) + ' →</a>' : '');
        x.insertBefore(e, x.firstChild);
      });
    }
    cartNote();
    var cdr = d.querySelector('cart-drawer');
    if (cdr && 'MutationObserver' in window) new MutationObserver(function () { if (!cdr.querySelector('.cp-cart')) cartNote(); }).observe(cdr, { childList: true, subtree: true });

    /* scheda prodotto: percentuale aggiornata al cambio variante, dai prezzi veri */
    d.addEventListener('variant:change', function (e) {
      var v = e.detail && e.detail.variant; if (!v) return;
      all('[data-cp-pdp]').forEach(function (box) {
        var m = {}; try { m = JSON.parse(box.getAttribute('data-cp-vars')); } catch (x) {}
        var p = m[v.id]; if (!p) return;
        var x = p[1] > p[0] ? Math.round((p[1] - p[0]) * 100 / p[1]) : 0;
        box.classList.toggle('is-sale', x > 0);
        var el = box.querySelector('[data-cp-pct]'); if (el) el.textContent = x > 0 ? '-' + x + '%' : '';
      });
    });
  }

  /* pannello anteprima: compare solo a chi sta guardando un'anteprima */
  function devPanel() {
    var d = document, c = window.esCP, cur = c.effCm ? 'cyber-monday' : (c.eff || 'standard');
    var L = [['standard', 'Standard'], ['black-month', 'Black Month'], ['black-week', 'Black Week'], ['black-friday', 'Black Friday'], ['cyber-monday', 'Cyber Monday'], ['auto', 'Esci']];
    var p = d.createElement('div'); p.className = 'cp-dev'; p.setAttribute('aria-label', 'Anteprima campagna');
    p.innerHTML = L.map(function (x) { return '<a href="?campaign=' + x[0] + '"' + (x[0] === cur ? ' class="on"' : '') + '>' + x[1] + '</a>'; }).join('');
    d.body.appendChild(p);
  }
})();
